import React, { useRef, useEffect } from 'react';
import { Card, Spin } from "antd";

const CreditSummaryCams = ({ creditSummaryData }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        if (iframeRef.current && creditSummaryData) {
            const iframe = iframeRef.current;
            const doc = iframe.contentDocument || iframe.contentWindow.document;

            doc.open();
            doc.write(creditSummaryData);
            doc.close();

            // Adjust height after content is loaded
            const resizeIframe = () => {
                if (iframe && iframe.contentWindow && iframe.contentDocument?.body) {
                    iframe.style.height = iframe.contentDocument.body.scrollHeight + "px";
                }
            };

            // Resize after content loads
            iframe.onload = resizeIframe;

            // Also trigger resize after short delay (in case iframe.onload doesn't fire reliably)
            setTimeout(resizeIframe, 300);
        }
    }, [creditSummaryData]);

    return (
        <Spin spinning={!creditSummaryData}>
            <Card className="w-80" style={{ margin: "0 auto", marginBottom: "1.5rem" }}>
                <iframe
                    ref={iframeRef}
                    title="Credit Summary"
                    style={{
                        width: "100%",
                        border: "none",
                        minHeight: "100px",
                        overflow: "hidden",
                    }}
                />
            </Card>
        </Spin>
    );
};

export default CreditSummaryCams;
